import type { FormContextData } from './types';

export function getEmptyFormContextData(): FormContextData {
  return {
    businessName: '',
    businessType: null,
    dedicatedSpace: null,
    businessSegments: [],
    acceptMarketing: false,

    firstName: '',
    lastName: '',
    email: '',
    password: '',
    phoneNumber: '',
    verificationCode: '',

    address: {
      street: '',
      city: '',
      postalCode: '',
      countryCode: '',
    },
  };
}
